import { Outlet, useNavigate } from "react-router-dom";
import CreateArtifactProvider, { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import ContainerNavigation from "../../../components/ContainerNavigation";
import { useNavigationBar } from "../../../context/NavigationContext";
import usePrompt from "../../../hooks/usePrompt";
import { useCallback, useContext, useEffect, useState } from "react";
import type { Blocker, BlockerFunction } from "react-router-dom";
import { useBlocker } from "react-router-dom";
import ConfirmationDialog from "../../../components/ConfiremationDialog";
import { useAuth } from "../../../context/AuthContext";
import { ContentState, getContentStatusString } from "../../../models/SKArtifact";

const CreateArtifactContextLayout = () => {
  const navContext = useNavigationBar();
  // const { showModal, confirmNavigation, cancelNavigation } = usePrompt("Are you sure you want to leave this page?", true);
  const {
    backArrow,
    title,
    subtitle,
    userActions,
    buttonTitle,
    enableLink,
    filterOption,
    onBack,
    getActionItems,
    onActionItemSelect,
    onClose,
    icon,
    onFilter,
    onNext,
    onEdit,
  } = navContext.navProps;

  // let shouldBlock: BlockerFunction = ({ currentLocation, nextLocation }) => {
  //   console.log(currentLocation.pathname);
  //   console.log(nextLocation.pathname);
  //   return (
  //     !nextLocation.pathname.startsWith("/dashboard/content") ||
  //     nextLocation.pathname === "/dashboard/content" ||
  //     nextLocation.pathname === "/dashboard/content/" ||
  //     nextLocation.pathname.includes("/dashboard/content/list")
  //   );
  // };

  return (
    <CreateArtifactProvider>
      {/* <div className="bg-white md:p-4"></div> */}
      <div className="container-modal">
        <div className="container-modal-content">
          <div className="bg-white ">
            <div className="relative">
              <ContainerNavigation
                backArrow={backArrow}
                title={title}
                subtitle={subtitle}
                userActions={userActions}
                icon={icon}
                enableLink={enableLink}
                buttonTitle={buttonTitle}
                filterOption={filterOption}
                onBack={onBack}
                onClose={onClose}
                onFilter={onFilter}
                getActionItems={getActionItems}
                onActionItemSelect={onActionItemSelect}
                onNext={onNext}
                onEdit={onEdit}
              />
              <ArtifactConfirmationDialogue />

              <div className="left-0 flex flex-col w-full h-screen overflow-y-auto top-[84px] pb-48">
                <ContentStatus />
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </CreateArtifactProvider>
  );
};

const ContentStatus = () => {
  const { contentData, isContentEditing } = useContext(CreateArtifactContext);

  return (
    <>
      {contentData && (
        <div className={`flex items-center justify-end gap-4 p-[3px] pr-3 ${isContentEditing ? "!bg-[#FFCC00] h-[28px] mb-[35px]" : ""} `}>
          {/* {contentData?.reactCount ? (
            <div className="flex items-center gap-1">
              <span className="">👍</span>
              <span className="capitalize edit-status-top  !text-sm !font-normal">{contentData.reactCount}</span>
            </div>
          ) : (
            <></>
          )}
          {contentData?.likeCount ? (
            <div className="flex items-center gap-1">
              <span className="text-red-500 ">❤️</span>
              <span className="capitalize edit-status-top !text-sm !font-normal">{contentData.likeCount}</span>
            </div>
          ) : (
            <></>
          )}
          {contentData?.bookmarkCount ? (
            <div className="flex items-center gap-1">
              <span className="text-sm">Bookmarks</span>
              <span className="capitalize edit-status-top !text-sm !font-normal">{contentData.bookmarkCount}</span>
            </div>
          ) : (
            <></>
          )} */}
          <div className="flex items-center gap-1">
            <p className="capitalize edit-status-top">{getContentStatusString(contentData?.status, contentData.subStatus)}</p>
            {!isContentEditing && contentData?.status === ContentState.ACTIVE && (
              <span>
                <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const ArtifactConfirmationDialogue = () => {
  const { saveData, unsavedChanges } = useContext(CreateArtifactContext);

  const shouldBlock: BlockerFunction = useCallback(
    ({ currentLocation, nextLocation }) => {
      console.log("Path previos", currentLocation.pathname);
      console.log("Path New", nextLocation.pathname);
      return (
        (!nextLocation.pathname.startsWith("/dashboard/content") ||
          nextLocation.pathname === "/dashboard/content" ||
          nextLocation.pathname === "/dashboard/content/" ||
          nextLocation.pathname === "/dashboard/content/list") &&
        unsavedChanges
      );
    },
    [unsavedChanges]
  );

  let blocker = useBlocker(shouldBlock);

  return (
    <ConfirmationDialog
      isOpen={blocker.state === "blocked"}
      onClose={() => blocker.reset?.()}
      onSave={async () => {
        await saveData();
        blocker.proceed?.();
      }}
      onDiscard={() => blocker.proceed?.()}
    />
  );
};

export default CreateArtifactContextLayout;
